import { format } from 'date-fns';

export const formatDate = (dateString: string): string => {
  const date = new Date(dateString);
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const yesterday = new Date(today);
  yesterday.setDate(today.getDate() - 1);

  const oneWeekAgo = new Date(today);
  oneWeekAgo.setDate(today.getDate() - 6);

  if (date.toDateString() === today.toDateString()) {
    return date.toLocaleTimeString('en-US', {
      hour12: true,
      hour: '2-digit',
      minute: '2-digit'
    });
  } else if (date.toDateString() === yesterday.toDateString()) {
    return 'Yesterday';
  } else if (date >= oneWeekAgo) {
    return date.toLocaleDateString('en-US', { weekday: 'short' });
  } else {
    return date.toLocaleDateString('en-GB', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    });
  }
};

export const getDateFormat = (date: Date): string => {
  return format(date, 'yyyy-MM-dd');
};

export const getTimeFormat = (date: Date | string): string => {
  if (typeof date === 'string') {
    date = new Date(date);
  }
  return date.toLocaleTimeString('en-US', {
    hour12: false,
    hour: '2-digit',
    minute: '2-digit'
  });
};

export const getSlotDate = (slotIndex: number, dayIndex: number, startDayOffset: number = 0, startHour: number = 9): Date => {
  const date = new Date();
  date.setHours(0, 0, 0, 0); // Reset to start of day

  // Add days offset
  date.setDate(date.getDate() + dayIndex + startDayOffset);

  // Calculate hours and minutes from slot index
  const totalMinutes = (startHour * 60) + (slotIndex * 30);
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;

  date.setHours(hours, minutes, 0, 0);

  return date;
};

export const formatDisplayDate = (dayIndex: number, startDayOffset: number): string => {
  const date = new Date();
  date.setDate(date.getDate() + dayIndex + startDayOffset);
  return date.toLocaleDateString('en-US', {
    weekday: 'short',
    month: 'short',
    day: 'numeric'
  });
};
